import React, { createContext, useContext, useState, PropsWithChildren } from "react";

// TODO REVIEW THIS

/** Minimal shape – expand with media tracks, peer connection, etc. */
export interface CallSession {
  roomId: string;
  startedAt: number;
}

export interface SessionState {
  /* `null`  ➜ not in a call            */
  /* object ➜ live call with metadata   */
  session: CallSession | null;

  /** create the session and store whatever you need */
  start(roomId: string): void;

  /** tear everything down (we’ll call this from AvatarStreamer) */
  end(): void;
}

const SessionContext = createContext<SessionState>({
  session: null,
  start: () => {},
  end: () => {},
});
export const useSession = () => useContext(SessionContext);

export const SessionProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [session, setSession] = useState<CallSession | null>(null);

  const start = (roomId: string) => {
    // TODO: create WebRTC transports, signalling socket, etc.
    setSession({ roomId, startedAt: Date.now() });
  };

  const end = () => {
    // TODO: close peer connection, stop tracks, remove listeners …
    setSession(null);
  };

  return (
    <SessionContext.Provider value={{ session, start, end }}>{children}</SessionContext.Provider>
  );
};
